// extracted by mini-css-extract-plugin
module.exports = {"container":"monday-status-picker_container__LzWjp","status":"monday-status-picker_status__sI_0C"};